(function () {
  if (window.customElements && customElements.get('free-shipping-bar')) return;

  var CART_MUTATION = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;
  var live = new Set();
  var debounce = null;

  function cartUrl() {
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    return root.replace(/\/$/, '') + '/cart.js';
  }

  function refresh() {
    fetch(cartUrl(), { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        live.forEach(function (el) { el.update(cart.total_price || 0); });
      })
      .catch(function () {});
  }

  function ping() {
    clearTimeout(debounce);
    debounce = setTimeout(refresh, 150);
  }

  // --- Watch for cart mutations, theme-agnostically -------------------------
  // Almost every theme (Dawn included) hits /cart/change.js, /cart/add.js etc.
  // Patching fetch/XHR catches all of them without depending on event names.
  if (window.fetch) {
    var nativeFetch = window.fetch;
    window.fetch = function () {
      var out = nativeFetch.apply(this, arguments);
      try {
        var a = arguments[0];
        var url = (a && a.url) || String(a || '');
        if (CART_MUTATION.test(url)) out.then(ping, function () {});
      } catch (e) {}
      return out;
    };
  }

  var nativeOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    try { this.__fsbCart = CART_MUTATION.test(String(url || '')); } catch (e) {}
    return nativeOpen.apply(this, arguments);
  };
  var nativeSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.send = function () {
    if (this.__fsbCart) this.addEventListener('load', ping);
    return nativeSend.apply(this, arguments);
  };

  // Belt and braces: common theme events + bfcache restores.
  ['cart:update', 'cart:updated', 'cart:refresh', 'cart-updated', 'cart:change', 'CartDrawer:updated']
    .forEach(function (name) { document.addEventListener(name, ping); });

  // Dawn's real hook is pubsub.js -> subscribe('cart-update'). That file is
  // loaded with `defer`, so `window.subscribe` does not exist yet while this
  // inline script is parsed. Try now, then again once parsing finishes.
  var subscribed = false;
  function hookPubSub() {
    if (subscribed || typeof window.subscribe !== 'function') return;
    try { window.subscribe('cart-update', ping); subscribed = true; } catch (e) {}
  }
  hookPubSub();
  document.addEventListener('DOMContentLoaded', hookPubSub);
  window.addEventListener('load', hookPubSub);
  window.addEventListener('pageshow', function (e) { if (e.persisted) ping(); });

  // --- The element ---------------------------------------------------------
  // A Shopify colour picker returns '' when cleared, and some themes hand back
  // a fully transparent value. Assigning either to style.backgroundColor is a
  // silent no-op, which shows as a bar that renders but stays invisible.
  function safeColor(value, fallback) {
    if (!value) return fallback;
    var v = String(value).trim().toLowerCase();
    if (v === 'none' || v === 'transparent' || v === 'rgba(0,0,0,0)' ||
        v === 'rgba(0, 0, 0, 0)' || v === '#00000000') return fallback;
    return value;
  }

  function money(cents, currency, locale) {
    try {
      return new Intl.NumberFormat(locale, {
        style: 'currency', currency: currency
      }).format(cents / 100);
    } catch (e) {
      return '$' + (cents / 100).toFixed(2);
    }
  }

  class FreeShippingBar extends HTMLElement {
    connectedCallback() {
      this.msg   = this.querySelector('[data-fsb-msg]');
      this.track = this.querySelector('[data-fsb-track]');
      this.fill  = this.querySelector('[data-fsb-fill]');

      // If this script is loaded without `defer`, any instance appearing later
      // in the document upgrades the moment its opening tag is parsed, before
      // its children exist. Wait for parsing to finish and try again.
      if (!this.msg || !this.fill) {
        if (!this.deferredInit) {
          this.deferredInit = true;
          document.addEventListener('DOMContentLoaded', this.connectedCallback.bind(this), { once: true });
        }
        return;
      }

      this.threshold     = Number(this.dataset.threshold) || 0;
      this.progressColor = safeColor(this.dataset.progressColor, '#62FF00');
      this.successColor  = safeColor(this.dataset.successColor, '#16803C');
      this.progressTpl   = this.dataset.progressMsg || "You're [amount] away from free shipping!";
      this.successMsg    = this.dataset.successMsg || '';
      this.currency      = this.dataset.currency || 'USD';
      this.locale        = this.dataset.locale || 'en';
      this.hideEmpty     = this.dataset.hideEmpty === 'true';
      this.wasComplete   = null;

      live.add(this);

      // Paint from the Liquid-rendered subtotal first (no blank flash),
      // then animate the fill in from zero.
      this.update(Number(this.dataset.subtotal) || 0, true);

      // Then confirm against the real cart, in case the page was cached
      // or this instance came back via section rendering.
      ping();
    }

    disconnectedCallback() {
      live.delete(this);
    }

    update(subtotal, animateIn) {
      if (this.hideEmpty && subtotal <= 0) { this.hidden = true; return; }
      this.hidden = false;

      var pct = this.threshold > 0
        ? Math.min((subtotal / this.threshold) * 100, 100)
        : 100;
      var complete = subtotal >= this.threshold;

      if (complete) {
        this.msg.textContent = this.successMsg;
        this.msg.style.color = this.successColor;
        if (this.wasComplete === false) {
          this.msg.classList.remove('fsb-win');
          void this.msg.offsetWidth;
          this.msg.classList.add('fsb-win');
        }
      } else {
        var remaining = money(this.threshold - subtotal, this.currency, this.locale);
        this.msg.textContent = this.progressTpl.replace('[amount]', remaining);
        this.msg.style.color = '';
        this.msg.classList.remove('fsb-win');
      }
      this.wasComplete = complete;

      this.fill.style.backgroundColor = complete ? this.successColor : this.progressColor;
      if (this.track) this.track.setAttribute('aria-valuenow', Math.round(pct));

      if (animateIn) {
        this.fill.style.width = '0%';
        this.fill.getBoundingClientRect(); // commit the 0% before animating
        var fill = this.fill;
        requestAnimationFrame(function () {
          requestAnimationFrame(function () { fill.style.width = pct + '%'; });
        });
      } else {
        this.fill.style.width = pct + '%';
      }
    }
  }

  customElements.define('free-shipping-bar', FreeShippingBar);
})();
